import * as AddPassenger from './AddPassenger.css';

export default {
	AddPassenger
};
